module.exports = __webpack_public_path__ + "img/cover-redeem-bg.588949af.jpg";